export default "__VITE_ASSET__iZP8bJrq__"